<template>
  <vs-sidebar
    click-not-close
    hidden-background
    position-right
    v-model="dialogShow"
    class="items-no-padding phone-edit sidebar-dialog">
    <div class="sidebar-content">

      <div class="customizer-header flex items-center justify-between px-6 sliderbar-header">
        <div>
          {{title}}
        </div>
        <feather-icon icon="XIcon" @click.stop="closeHandle" class="cursor-pointer"></feather-icon>
      </div>
      <VuePerfectScrollbar class="scroll-area--customizer pt-4 pb-6" :settings="settings" :key="$vs.rtl">
        <div class="content px-6">
          <el-form
            ref="form"
            :model="form"
            :rules="rules"
          >
            <el-form-item
              :label="$t('User.newPhone')"
              prop="addPhones"
            >
              <el-input
                v-model="form.addPhones"
                :placeholder="phFileter('User.newPhone')"
              >
                <el-select
                  style="width: 100px;"
                  class="phoneTitle"
                  v-model="phoneTitle"
                  slot="prepend"
                  filterable
                  :filter-method="dataFilter"
                  :placeholder="phFileter('root.selectPls')"
                >
                  <el-option
                    v-for="item in nationCodeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label"
                  >
                    <span>{{`${item.label} ${item.description}`}}</span>
                  </el-option>
                </el-select>
              </el-input>
            </el-form-item>
            <el-form-item
              :label="$t('User.phoneVerCode')"
              prop="code"
            >
              <div class="code-box pr">
                <el-input
                  v-model="form.code"
                  :placeholder="phFileter('Register.verText')"
                ></el-input>
                <div
                  class="sendMes pa theme-font"
                >
                                <span v-if="isCode"
                                      @click="getCode"
                                      class="active"
                                >{{$t('User.sendVeri')}}</span>
                  <span v-else>{{isCodeNumber}}s {{$t('User.sendDesc')}}</span>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </VuePerfectScrollbar>
    </div>
    <div
      class="footer-sidebar" slot="footer">
      <el-button
        @click="cancelHandle"
        type="text"
        class="calcel-btn"
      >{{$t('cancel')}}</el-button>
      <vs-button
        @click="submitHandle"
        color="primary"
        :disabled="submitLoading"
      >
        <span v-if="submitLoading"><i class="el-icon-loading"></i> </span>
        {{$t('confirm')}}
      </vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import { getDictListByType } from '@/api/home.js';
import { getDictByTypeAsync } from '@/utils/cacheService';
import { mapGetters } from 'vuex';
import { isMobile } from '@/utils/validate';
import { getAddPhoneVer, addPhoneSubmit } from '@/api/userCenter.js';

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  name: "phoneEditDialog",
  components:{
    VuePerfectScrollbar
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
  },
  data() {
    let _this = this;
    var checkAddPhones = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('phoneEmtpyTips')));
      }
      setTimeout(() => {
        if (value === '') {
          callback(new Error(this.$t('User.plsInputNewPhone')));
        } else {
          if (!isMobile(value, this.phoneTitle)) {
            callback(new Error(this.$t('Register.errorPhon')));
          } else {
            callback();
          }
        }
      }, 1000);
    };
    return {
      settings: {
        maxScrollbarLength : 60,
        wheelSpeed         : .60,
      },
      title: _this.$t('mobile_phone'),

      form: {
        addPhones: '',
        code: ''
      },
      rules: {
        addPhones: [
          { required: true, message: _this.$t('phoneEmtpyTips'), trigger: 'blur' },
          { validator: checkAddPhones, trigger: 'blur' },
        ],
        code: [
          { required: true, message: this.$t('Partner.inputVer'), trigger: 'blur' }
        ]
      },
      phoneTitle: '+86',
      nationCodeList: [],
      nationCodeListMaster: [],
      // 验证码
      loading: false,
      isCode: true,
      isCodeNumber: 60,
      codeLoading: false,
      submitLoading: false,
    }
  },

  watch: {

  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  created(){
    this.getNationCodeList();
  },
  methods: {
    getNationCodeList(){
      getDictByTypeAsync(getDictListByType, 'phoneList').then((data) => {
        if(data[0].type == 'phoneList') {
          this.nationCodeList = data;
          this.nationCodeListMaster = data;
        }
      })
    },
    dataFilter(val){
      this.phoneTitle = val;
      if (val) { //val存在
        this.nationCodeList = this.nationCodeListMaster.filter((item) => {
          if((item.label.indexOf(val) > -1) || (item.description.toUpperCase().indexOf(val.toUpperCase()) > -1)){
            return true
          }
        })
      } else {
        //val为空时，还原数组
        this.nationCodeList = this.nationCodeListMaster;
      }
    },
    getCode() {
      if (this.codeLoading || !this.isCode) return;
      let parmas = {
        newPhone: this.form.addPhones,
        nationCode: this.phoneTitle
      };
      if (!this.form.addPhones) {
        this.$refs.form.validateField('addPhones');
        return;
      }
      this.codeLoading = true;
      getAddPhoneVer(parmas).then((res) => {
        this.$message({
          message: this.$t('User.verCodeSendSuccess'),
          type: 'success'
        });
        this.isCode = false;
        this.timerOut();
        this.isCodeNumber = 60;
      }).finally(() => {
        this.codeLoading = false;
      });
    },
    timerOut() {
      let _this = this;
      let timer1 = setTimeout(() => {
        clearTimeout(timer1);
        if (_this.isCodeNumber > 0) {
          _this.isCodeNumber = --_this.isCodeNumber;
          _this.timerOut();
        } else {
          clearTimeout(timer1);
          this.isCode = true;
        }
      }, 1000);
    },

    close(){
      this.$emit('close')
    },
    closeHandle() {
      this.close();
    },
    phFileter(data){
      return this.$t(data);
    },

    interfaceAjaxSuccess(){
      this.$emit('ajax-success');
    },
    submitHandle(){
      if (this.submitLoading) return;
      this.$refs.form.validate((valid) => {
        if(valid){
          let parmas = {
            nationCode: this.phoneTitle,
            newPhone: this.form.addPhones,
            phoneVerCode: this.form.code,
            preOperationId: this.$parent.preOperationId,
          };
          this.submitLoading = true;
          addPhoneSubmit(parmas).then((res) => {
            if (res.status == 10000) {
              this.$message({
                message: `${this.$t('editSuceess')}${this.$t('Need_to_log_in_again')}`,
                type: 'success'
              });

              this.interfaceAjaxSuccess();
            } else {
              const field = this.$refs.form.fields[1];
              field.validateMessage = res.message;
              field.validateState = 'error'
            }

          }).finally(() => {
            this.submitLoading = false;
          });

        }else {
          console.log('error');
        }
      })
    },
    cancelHandle(){
      this.close();
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../../../assets/scss/variable";
.phone-edit {
  .content {
    .text-box {
      background-color: #F8F8F8;
      padding: 10px;
      border-radius: 6px;
      .text-box-line {
        margin-bottom: 10px;
        font-size: 14px;
        .text-left {
          color: #A29FAE;
        }
        .data-right {
          color: #6E6B7B;
        }
      }
    }
    .elform {
      margin-top: 30px;
    }
    .code-box {
      position: relative;
      .sendMes {
        line-height: 14px;
        position: absolute;
        bottom: 13px;
        right: 20px;
        text-align: right;
        color: $themeColor;
        span {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.phone-edit {
  .vs-sidebar--items {

  }
  .scroll-area--customizer {
    height: calc(100% - 5rem);
  }
  .vs-sidebar {
    position: fixed;
    z-index: 999;
    .sidebar-content {
    }
  }
  .footer-sidebar {
    padding: 20px 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .calcel-btn {
      margin-right: 10px;
    }
  }
}
</style>
